export const api = {
  car: {
    getRecordList: '/vas/appointment/queryVehicleApplyRecordList.json',
    getDetails: '/vas/appointment/queryAppointmentDetail.json',
    getWorkFlow: '/vas/appointment/queryAppointmentWorkflow.json'
  }
}